<template>
  <div class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-tight sm:block">
      <p class="ml-auto font-semibold items-right">{{ userInfo }}</p>
      <p class="flex items-center" v-if="contracts.length == 0"><small>บัญชีเงินกู้: {{ contract.contractNo }}</small></p>
      <a class="flex items-center" v-if="contracts.length >= 2" href="#" @click="handlePopup()"><small>บัญชีเงินกู้: {{ contract.contractNo }}</small><i class="material-icons"> expand_more </i></a>
    </div>
    <vs-popup :title="title" :active.sync="active">
      <ul class="contract-list">
        <li class="contract-item" v-for="(item, index) in contracts" :key="index">
          <a class="flex items-center contract-link" @click.prevent="changeContract(item.id)">บัญชีเงินกู้: {{ item.contractNo }}</a>
        </li>
      </ul>
    </vs-popup>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import {IPaymentAmountDetailType} from "@/constants/interface";
const { mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')
export default {
  data () {
    return {
      title: "เลือกเลขที่สัญญา",
      active: false,
      content: ""
    }
  },
  computed: {
    ...mapAccountingState(['status', 'contract', 'contracts']),
    userInfo () {
      if(this.$store.state.currentUser){
        const prefix = this.$store.state.currentUser.prefix ? this.$store.state.currentUser.prefix.nameTh : ""
        const name = this.$store.state.currentUser.name
        const surname = this.$store.state.currentUser.surname
        return `${prefix}${name} ${surname}`
      }else{
        return ""
      }
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    currentUser () {
      return this.$store.state.currentUser
    },
    currentUserPhoto () {
      return this.$store.getters['getCurrentUserPhoto']
    },
  },
  methods: {
    ...mapAccountingActions(['getContractsByCurrentUser', 'getContract', 'getTransactionsActionByContractId', 'getLastPaymentByContractId', 'getPaymentAmountDetailByContractId', 'getPaymentRoundDetailByContractId']),
    async changeContract (id){
      const vm = this
      const { getContractsByCurrentUser, getContract, getTransactionsActionByContractId, getLastPaymentByContractId, getPaymentAmountDetailByContractId } = vm
      this.active = false;
      await getContractsByCurrentUser()
      await getContract({ form: {id: id} });
      if(vm.$router.history.current.path === "/"){
        vm.$vs.loading()
        await getTransactionsActionByContractId({
          form: {
            contractId: vm.contract.id,
            filters: {
              limit: 3,
              action: 'All',
              year: 0
            }
          }
        });
        await getLastPaymentByContractId({form: {contractId: vm.contract.id}});
        await getPaymentAmountDetailByContractId({form: {contractId: vm.contract.id, type: IPaymentAmountDetailType.normal, amount: 0}});
        // await vm.getPaymentRoundDetailByContractId({form: {contractId: vm.contract.id}});
        setTimeout(() => {
          vm.$vs.loading.close();
        }, 500)
      }else{
        await vm.$router.push("/")
      }

    },
    async handlePopup(){
      this.active = true
    },
    logout () {
      const vm = this
      vm.$vs.loading()
      vm.$store.dispatch('signOut', vm)
      setTimeout(() => {
        vm.$vs.loading.close()
      }, 2000)
    }
  }
}
</script>

<style scoped>
.contract-list {
  list-style-type: none;
  padding: 0;
}

.contract-item {
  margin: 10px 0;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
}

.contract-item:last-child {
  border-bottom: none;
}

.contract-link {
  color: #333;
  text-decoration: none;
  font-size: 16px;
}
</style>
